var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 512,
    viewBox: "0 0 1035 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1035,
    height: 512,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.8 1.19999C375.8 -3.70001 358.1 6.19999 353.2 23.2L225.2 471.2C220.3 488.2 230.2 505.9 247.2 510.8C264.2 515.7 281.9 505.8 286.8 488.8L414.8 40.8C419.7 23.8 409.8 6.09999 392.8 1.19999ZM473.4 121.3C460.9 133.8 460.9 154.1 473.4 166.6L562.7 256L473.3 345.4C460.8 357.9 460.8 378.2 473.3 390.7C485.8 403.2 506.1 403.2 518.6 390.7L630.6 278.7C643.1 266.2 643.1 245.9 630.6 233.4L518.6 121.4C506.1 108.9 485.8 108.9 473.3 121.4L473.4 121.3ZM166.7 121.3C154.2 108.8 133.9 108.8 121.4 121.3L9.39999 233.3C-3.10001 245.8 -3.10001 266.1 9.39999 278.6L121.4 390.6C133.9 403.1 154.2 403.1 166.7 390.6C179.2 378.1 179.2 357.8 166.7 345.3L77.3 256L166.7 166.6C179.2 154.1 179.2 133.8 166.7 121.3Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M309.6 300.4L490.3 469.1C497.8 476.1 507.7 480 518 480C528.3 480 538.2 476.1 545.7 469.1L726.4 300.4C756.8 272.1 774 232.4 774 190.9V185.1C774 115.2 723.5 55.6 654.6 44.1C609 36.5 562.6 51.4 530 84L518 96L506 84C473.4 51.4 427 36.5 381.4 44.1C312.5 55.6 262 115.2 262 185.1V190.9C262 232.4 279.2 272.1 309.6 300.4Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M787.775 1.19999C770.775 -3.70001 753.075 6.19999 748.175 23.2L620.175 471.2C615.275 488.2 625.175 505.9 642.175 510.8C659.175 515.7 676.875 505.8 681.775 488.8L809.775 40.8C814.675 23.8 804.775 6.09999 787.775 1.19999ZM868.375 121.3C855.875 133.8 855.875 154.1 868.375 166.6L957.675 256L868.275 345.4C855.775 357.9 855.775 378.2 868.275 390.7C880.775 403.2 901.075 403.2 913.575 390.7L1025.57 278.7C1038.07 266.2 1038.07 245.9 1025.57 233.4L913.575 121.4C901.075 108.9 880.775 108.9 868.275 121.4L868.375 121.3ZM561.675 121.3C549.175 108.8 528.875 108.8 516.375 121.3L404.375 233.3C391.875 245.8 391.875 266.1 404.375 278.6L516.375 390.6C528.875 403.1 549.175 403.1 561.675 390.6C574.175 378.1 574.175 357.8 561.675 345.3L472.275 256L561.675 166.6C574.175 154.1 574.175 133.8 561.675 121.3Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1035,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 512,
    fill: "white",
    transform: "translate(858)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e5ef5d2e65059960e2665f2fe58ec092.svg";
export { ForwardRef as ReactComponent };